import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { Application, FileTypes, Mpi, LicenseCheckFlag, Fabric } from 'src/app/core/models/application';
import { ApplicationService } from 'src/app/core/services/application.service';
import { MatSelect } from '@angular/material/select';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-update-application',
  templateUrl: './update-application.component.html',
  styleUrls: ['./update-application.component.scss']
})
export class UpdateApplicationComponent implements OnInit {
  
  constructor(
    public dialog: MatDialogRef<UpdateApplicationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { application: Application },
    private applicationService: ApplicationService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialog,
    private _spinner: NgxSpinnerService,
  ) { }

  submitActive: boolean = false;
  updateApplicationForm;
  FormGroup;
  application: Application = this.data.application;
  executeFiles = [];
  licenseFiles = [];
  graphFiles = [];
  cancelFiles = [];
  resumeFiles = [];
  suspendFiles = [];
  uploadExecuteFile: File;
  toShow: boolean = false;
  uploadFlag: boolean = false;
  scriptFileUploadPer: string;
  cancelledFiles = {};
  scriptUploadSub: Subscription;
  depName: string = "";
  fileName: string = "";
  queuesFromDep: string[] = [];
  alreadyAttachedNodeGroups: string[] = [];
  @ViewChild('select') select: MatSelect;

  types: FileTypes[] = [
    { name: 'Execute File', value: '0' },
    { name: 'License File', value: '1' },
    { name: 'Cancel File', value: '2' },
    { name: 'Resume File', value: '3' },
    { name: 'Suspend File', value: '4' },
    { name: 'Graph File', value: '5' }
  ];
  mpis: Mpi[] = [
    { name: 'Intel MPI', value: '0' },
    { name: 'MPICH', value: '1' },
    { name: 'OpenMPI', value: '2' },
    { name: 'Platform MPI', value: '3' },
  ]
  licenseCheckFlags: LicenseCheckFlag[] = [
    { name: 'Enabled', value: 'True' },
    { name: 'Disabled', value: 'False' }
  ]
  fabrics: Fabric[] = [
    { name: 'dapl', value: "0" },
    { name: 'tcp', value: "1" },
    { name: 'shm', value: "2" },
    { name: 'tmi', value: "3" },
    { name: 'ofa', value: "4" },
    { name: 'ofi', value: "5" },
    { name: 'efa', value: "6" }
  ]

  @ViewChild('chooseAppFile') chooseAppFile;

  ngOnInit() {
    this.depName = this.applicationService.tempDeployName;
    this.updateApplicationForm = new UntypedFormGroup({
      modulesApp: new UntypedFormControl(''),
      staticCores: new UntypedFormControl('', [Validators.pattern(/^\d+(,\d+)*$/)]),
      appMpi: new UntypedFormControl('', Validators.required),
      licenseCheck: new UntypedFormControl('', Validators.required),
      fabricCheck: new UntypedFormControl('', Validators.required),
      // userScriptFile: new UntypedFormControl({ value: null, disabled: true }),
      applicationSpecificQueue: new UntypedFormControl(''),
      defaultMemorySpace: new UntypedFormControl(null, Validators.pattern('^[0-9]*$')),
    });

    this.applicationService.getNodeGroupsForDeployment(this.application.depName)
      .subscribe((data) => {
        if (data) {
          this.queuesFromDep = <string[]>JSON.parse(JSON.stringify(data));
        }
      });

    this.autoFillDetails();
    // this.updateApplicationForm.controls["fileTypeApp"].valueChanges.subscribe(val => {
    //   this.updateApplicationForm.controls["userScriptFile"].setValue(null);
    //   this.toShow = false;
    // })
  }

  autoFillDetails() {
    if (this.application?.applicationNodeGroups) {
      this.alreadyAttachedNodeGroups = this.application?.applicationNodeGroups?.split(",");
    }
    this.updateApplicationForm.controls['modulesApp'].setValue(this.application.modules)
    this.updateApplicationForm.controls['staticCores'].setValue(this.application.staticCores)
    this.updateApplicationForm.controls['applicationSpecificQueue'].setValue(this.application?.applicationNodeGroups);
    this.setMpi(this.application.mpi)
    this.setLicenseCheck(this.application.checkLicense)
    this.setFabric(this.application.fabric)
    this.updateApplicationForm.controls['defaultMemorySpace'].setValue(this.application?.memoryPerCPU)
    // if (this.application.licenseFile && this.application.licenseFile.includes(',')) {
    //   this.licenseFiles = this.application.licenseFile.split(',')
    // } else {
    //   if (this.application.licenseFile != null) this.licenseFiles.push(this.application.licenseFile)
    // }
  
    // if (this.application.executeFile && this.application.executeFile.includes(',')) {
    //   this.executeFiles = this.application.executeFile.split(',')
    // } else {
    //   if (this.application.executeFile != null) {
    //     if (!this.executeFiles.includes(this.application.executeFile)) {
    //       this.executeFiles.push(this.application.executeFile)
    //     }
    //   }
    // }
    // if (this.application.graphFiles && this.application.graphFiles.includes(',')) {
    //   this.graphFiles = this.application.graphFiles.split(',')
    // } else {
    //   if (this.application.graphFiles != null) {
    //     if (!this.graphFiles.includes(this.application.graphFiles)) {
    //       this.graphFiles.push(this.application.graphFiles)
    //     }
    //   }
    // }

    // if (this.application.cancelFile && this.application.cancelFile.includes(',')) {
    //   this.cancelFiles = this.application.cancelFile.split(',');
    // } else {
    //   if (this.application.cancelFile != null) {
    //     if (!this.cancelFiles.includes(this.application.cancelFile)) {
    //       this.cancelFiles.push(this.application.cancelFile)
    //     }
    //   }
    // }

    // if (this.application.resumeFile && this.application.resumeFile.includes(',')) {
    //   this.resumeFiles = this.application.resumeFile.split(',');
    // } else {
    //   if (this.application.resumeFile != null) {
    //     if (!this.resumeFiles.includes(this.application.resumeFile)) {
    //       this.resumeFiles.push(this.application.resumeFile)
    //     }
    //   }
    // }

    // if (this.application.suspendFile && this.application.suspendFile.includes(',')) {
    //   this.suspendFiles = this.application.suspendFile.split(',');
    // } else {
    //   if (this.application.suspendFile != null) {
    //     if (!this.suspendFiles.includes(this.application.suspendFile)) {
    //       this.suspendFiles.push(this.application.suspendFile)
    //     }
    //   }
    // }
    // this.updateApplicationForm.controls['graphFilesApp'].setValue(this.graphFiles)
    // this.updateApplicationForm.controls['executeFilesApp'].setValue(this.executeFiles)
    // this.updateApplicationForm.controls['licenseScript'].setValue(this.licenseFiles)
    // this.updateApplicationForm.controls['resumeScript'].setValue(this.resumeFiles)
    // this.updateApplicationForm.controls['suspendScript'].setValue(this.suspendFiles)
    // this.updateApplicationForm.controls['cancelScript'].setValue(this.cancelFiles)
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
  }

  setMpi(flag) {
    let idx;
    this.mpis.findIndex(mpi => {
      if (mpi.name == flag) {
        idx = this.mpis.findIndex(x => x.name == flag);
      }
    })
    this.updateApplicationForm.controls['appMpi'].setValue(this.mpis[idx])
  }

  setFabric(fabricValue) {
    let idx;
    this.fabrics.findIndex(fabric => {
      if (fabric.name == fabricValue) {
        idx = this.fabrics.findIndex(x => x.name == fabricValue);
      }
    })
    this.updateApplicationForm.controls['fabricCheck'].setValue(this.fabrics[idx])
  }

  setLicenseCheck(flag) {
    let idx;
    this.licenseCheckFlags.findIndex(mpi => {
      if (mpi.value == flag) {
        idx = this.licenseCheckFlags.findIndex(x => x.value == flag);
      }
    })
    this.updateApplicationForm.controls['licenseCheck'].setValue(this.licenseCheckFlags[idx])
  }

  showError(form) {
    form.controls.executeFilesApp.touched = true;
    form.controls.graphFilesApp.touched = true;
    form.controls.modulesApp.touched = true;
    form.controls.appMpi.touched = true;
    form.controls.licenseCheck.touched = true;
    form.controls.licenseScript.touched = true;
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(form) {
    if (form.status == 'INVALID') {
      this.showError(form);
    } else {
      let updateAppData: Application = {
        appName: this.application.appName,
        appVersion: this.application.appVersionText,
        modules: form.value.modulesApp,
        mpi: form.value.appMpi.value,
        licenseCheckFlag: form.value.licenseCheck.value,
        fabric: form.value.fabricCheck.value,
        staticCores: form.value.staticCores,
        applicationNodeGroups: form.value.applicationSpecificQueue?.toString(),
        memoryPerCPU: form.value.defaultMemorySpace?.toString(),
        graphFiles: this.application.graphFiles,
        executeFile: this.application.executeFile,
        licenseFile: this.application.licenseFile,
        resumeFile: this.application.resumeFile,
        cancelFile: this.application.cancelFile,
        suspendFile: this.application.suspendFile,
        customActionFile: this.application.customActionFile,
      };
      this.dialog.close({ updatedApp: updateAppData, currApp: this.application });
    }
  }

  removeFile(id) {
    if (this.cancelledFiles[id]) {
      this.cancelledFiles[id].next();
      this.cancelledFiles[id].complete();
    }
    this.uploadExecuteFile = null
    this.updateApplicationForm.controls[id].setValue(null);
    this.toShow = false;
  }
}
